import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { BaseBreadcrumbs } from '@mgm/common/components/base';
import { TimeoffTable, TimeoffTotalsHeader } from './Timeoff';

const TimeoffView = () => {
  const { t } = useTranslation(['schedule', 'nav', 'common']);

  return (
    <Box>
      <BaseBreadcrumbs
        heading={t('timeoffRequest', { ns: 'schedule' })}
        links={[
          { name: t('schedules', { ns: 'nav' }), href: '/schedules/weekly' },
          { name: t('timeoffs', { ns: 'nav' }), href: '/schedules/timeoff' },
        ]}
      />
      <TimeoffTotalsHeader />
      <TimeoffTable />
    </Box>
  );
};

export {
  TimeoffView,
};
